import React, { useState } from 'react';
import './style.css';
import '../navbar-mobile/style.css';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/theme-context';
import { Menu, Moon, Sun } from 'react-feather';
import { AddAccount } from '../add-account';
import { useAuth } from '../../contexts/auth-context';
import { NavbarThemes } from '../navbar-themes/indext';
import { Icon } from '../icon';
import { useTranslation } from "react-i18next";
import { MenuIcon } from 'lucide-react';

interface NavbarPCProps {
  title?: string;
  img?: string;
  isMenuRounded?: string;
  linkProfile?: string;
  isMenuFixed?: string;
  showMenuIcon?: boolean;
  children?: React.ReactNode;
  className?: string;
  actionSearch?: string;
  showSearchForm?: boolean;
  searchForm?: React.ReactNode;
}

const NavbarPC: React.FC<NavbarPCProps> = ({ title, actionSearch, img, searchForm, children, showMenuIcon, showSearchForm, className, isMenuRounded = false, isMenuFixed = false, linkProfile }) => {
    const { t } = useTranslation();
    const { isNewUI, isDarkMode, toggleDarkMode } = useTheme();
    const { isAuthenticated } = useAuth();
    const [isDropdownVisible, setDropdownVisible] = useState(false);

  return (
    <nav className={`${className} navbar navbar-pc navbar-dark user-select-none navbar-expand-md ${isMenuRounded ? "menu-radius" : ""} ${isMenuFixed ? "fixed-top" : ""}`} id='navbar-pc'>
         <div className="container-fluid">
             <Link className="navbar-brand" to="/"><img alt={`Logo do ${title}`} src={img}/></Link>
             <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                 <span className="navbar-toggler-icon"></span>
             </button>
             <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <NavbarThemes />

                 <ul className="navbar-nav me-auto mb-lg-0">
                     <li className="nav-item">
                        {showSearchForm && !searchForm && (
                            <form className="d-flex" method="GET" action={actionSearch ?? "/pesquisa"} role="search" id='form-search'>
                                <input className="form-control search-menu" id="input-search" type="text" name="termo" placeholder="Pesquisar" aria-label="termo" required/>
                                    <button className="btn btn-search-menu" type="submit">
                                        <img height="30px" src="/img/search.png" alt=""/>
                                    </button>

                            </form>
                        )}

                        {searchForm}
                     </li>
                 </ul>
                 <div className="d-flex div-icons-nav" role="search">
                    {/* HOME */}
                    <ul className="navbar-nav me-auto mb-lg-0">
                        <>
                            {children}
                            <span style={{cursor: "pointer"}} onClick={() => toggleDarkMode()} id="darkModeToggle" className="cursor-pointer link-menu-right d-flex align-items-center justify-content-start">
                                { isDarkMode ? (
                                    <div className="nav-link nav-link-pc">
                                        <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} size={32} name="sunny">
                                            <Sun className='icon-menu-dark'/>
                                        </Icon>
                                    </div>
                                ) : (
                                    <div className="nav-link nav-link-pc">
                                        <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} size={32} name="bedtime">
                                            <Moon className='icon-menu-dark'/>
                                        </Icon>
                                        
                                    </div>
                                ) }
                            </span>

                            {showMenuIcon ? (
                                    <div className="nav-link" style={{ cursor: "pointer", padding: 0 }}>
                                        <Icon data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)} size={32} name="menu">
                                            <MenuIcon data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" className='icon-menu-dark'/>
                                        </Icon>
                                    </div>
                            ) : null}

                            { isAuthenticated ? (
                                <AddAccount setDropdownVisible={setDropdownVisible} isDropdownVisible={isDropdownVisible} linkProfile={linkProfile}/>
                            ) : (
                                <>
                                    <span className="nav-item">
                                        <Link aria-label="Ir para tela de login" id='btn-login-menu-pc' className="nav-link btn-login-menu-pc position-relative" to="/login">
                                            {t("login.title")}
                                        </Link>
                                    </span>
                                    <span className="nav-item">
                                        <Link aria-label="Ir para tela de login" id='btn-login-menu-pc' className="nav-link btn-login-menu-pc position-relative" to="/cadastro">
                                            {t("register.title")}
                                        </Link>
                                    </span>
                                </>
                            )}
                         </>
                     </ul>
                 </div>
             </div>
         </div>
    </nav>
  );
};

export default NavbarPC;


